import { render } from "./DoublingContent.vue?vue&type=template&id=0ff29e32&scoped=true"
import script from "./DoublingContent.vue?vue&type=script&lang=js"
export * from "./DoublingContent.vue?vue&type=script&lang=js"

import "./DoublingContent.vue?vue&type=style&index=0&id=0ff29e32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff29e32"]])

export default __exports__